import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHealthy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Healthy"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="url(#Healthy_svg__a)"
      d="M0 14.4C0 6.447 6.447 0 14.4 0h25.2C47.553 0 54 6.447 54 14.4v25.2C54 47.553 47.553 54 39.6 54H14.4C6.447 54 0 47.553 0 39.6z"
      opacity={0.35}
      transform="scale(.37037)"
    />
    <g transform="translate(2.963 2.963)scale(.37037)">
      <circle cx={18.9} cy={18.9} r={15.12} fill="url(#Healthy_svg__b)" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M27.085 12.715a1.467 1.467 0 0 1 0 2.075l-10 10.001c-.795.794-2.08.8-2.881.013l-3.937-3.868a1.468 1.468 0 0 1 2.057-2.093l3.308 3.25 9.378-9.378a1.47 1.47 0 0 1 2.075 0"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="Healthy_svg__a"
        x1={43.874}
        x2={-23.626}
        y1={39.657}
        y2={38.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3DA592" />
        <stop offset={1} stopColor="#C3E3DD" />
      </linearGradient>
      <linearGradient
        id="Healthy_svg__b"
        x1={28.349}
        x2={-9.451}
        y1={25.988}
        y2={25.2}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3DA592" />
        <stop offset={1} stopColor="#C3E3DD" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgHealthy;
